import React from 'react';
import { motion } from 'framer-motion';
interface ContentSectionProps {
  children: ReactNode;
  className?: string;
  id?: string;
  background?: 'white' | 'gray';
  delay?: number;
}
export function ContentSection({
  children,
  className = '',
  id,
  background = 'white',
  delay = 0
}: ContentSectionProps) {
  const bgColor = background === 'white' ? 'bg-[#FAFAFA]' : 'bg-[#F3F4F6]';
  return <section id={id} className={`py-16 md:py-24 px-4 md:px-8 w-full ${bgColor} ${className}`} data-id="element-169">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.8,
      ease: 'easeOut',
      delay
    }} className="max-w-4xl mx-auto" data-id="element-170">
        {children}
      </motion.div>
    </section>;
}